// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"7533":"5a980e842217d5a1","8954":"f490d30062172a51"}[chunkId] + ".css";
};